// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generate_generate_container__b6Uza {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-top: none;
  border-left: none;
  padding: 20px 25px 0 25px;
}
@media screen and (max-width: 1850px) {
  .generate_generate_container__b6Uza {
    padding: 17px 10px 0 10px;
  }
}
@media screen and (max-width: 781px) {
  .generate_generate_container__b6Uza {
    padding: 17px 14px 0 17px;
  }
}
.generate_generate_container__b6Uza .generate_generate_brand__FFfDw {
  width: 100%;
  display: flex;
}
.generate_generate_container__b6Uza .generate_generate_brand__FFfDw span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  margin-left: 7px;
}
@media screen and (max-width: 781px) {
  .generate_generate_container__b6Uza .generate_generate_brand__FFfDw span {
    font-size: 18px;
  }
}
.generate_generate_container__b6Uza .generate_select__DngOU {
  width: 100%;
  margin-top: 20px;
}
.generate_generate_container__b6Uza .generate_select__DngOU .generate_subLabel__rzd75 {
  color: var(--re-from-color) !important;
}
.generate_generate_container__b6Uza .generate_select__DngOU .generate_label__-UD9C,
.generate_generate_container__b6Uza .generate_select__DngOU .generate_subLabel__rzd75 {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 17px;
}
@media screen and (max-width: 781px) {
  .generate_generate_container__b6Uza .generate_select__DngOU .generate_label__-UD9C,
  .generate_generate_container__b6Uza .generate_select__DngOU .generate_subLabel__rzd75 {
    margin-top: 14px;
    margin-left: 3px;
  }
}
.generate_generate_container__b6Uza .generate_select__DngOU .generate_selectPlan__Z88EV {
  width: 100%;
  background: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
.generate_generate_container__b6Uza .generate_select__DngOU select {
  margin-top: 11px;
}
@media screen and (max-width: 781px) {
  .generate_generate_container__b6Uza .generate_select__DngOU select {
    height: 42px;
  }
}
.generate_generate_container__b6Uza .generate_option__y34VO {
  width: 100%;
  display: flex;
  margin-top: 18px;
}
@media screen and (max-width: 781px) {
  .generate_generate_container__b6Uza .generate_option__y34VO button {
    right: 0;
  }
}
.generate_generate_container__b6Uza .generate_option__y34VO button {
  margin-left: 11px;
}
.generate_generate_container__b6Uza .generate_option__y34VO button:first-child {
  margin-left: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/generate/generate.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AACF;AACE;EARF;IASI,yBAAA;EAEF;AACF;AAAE;EAZF;IAaI,yBAAA;EAGF;AACF;AADE;EACE,WAAA;EACA,aAAA;AAGJ;AADI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAGN;AADM;EATF;IAUI,eAAA;EAIN;AACF;AAAE;EACE,WAAA;EACA,gBAAA;AAEJ;AAAI;EACE,sCAAA;AAEN;AACI;;EAEE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACN;AACM;EAVF;;IAWI,gBAAA;IACA,gBAAA;EAGN;AACF;AAAI;EACE,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AAEN;AACI;EACE,gBAAA;AACN;AACM;EAHF;IAII,YAAA;EAEN;AACF;AAEE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AAEI;EACE;IACE,QAAA;EAAN;AACF;AAGI;EACE,iBAAA;AADN;AAGI;EACE,2BAAA;AADN","sourcesContent":[".generate_container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--sb-border-color);\n  border-top: none;\n  border-left: none;\n  padding: 20px 25px 0 25px;\n\n  @media screen and (max-width: 1850px) {\n    padding: 17px 10px 0 10px;\n  }\n\n  @media screen and (max-width: 781px) {\n    padding: 17px 14px 0 17px;\n  }\n\n  .generate_brand {\n    width: 100%;\n    display: flex;\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 34px;\n      margin-left: 7px;\n\n      @media screen and (max-width: 781px) {\n        font-size: 18px;\n      }\n    }\n  }\n\n  .select {\n    width: 100%;\n    margin-top: 20px;\n\n    .subLabel {\n      color: var(--re-from-color) !important;\n    }\n\n    .label,\n    .subLabel {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 17px;\n\n      @media screen and (max-width: 781px) {\n        margin-top: 14px;\n        margin-left: 3px;\n      }\n    }\n\n    .selectPlan {\n      width: 100%;\n      background: var(--re-select-dark-bg);\n      border-radius: 12px;\n      border: 1px solid transparent;\n      color: var(--font-dark-color);\n      font-family: Red Hat Display;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n      padding: 11px 20px 10px 16px;\n      margin-top: 17px;\n    }\n\n    select {\n      margin-top: 11px;\n\n      @media screen and (max-width: 781px) {\n        height: 42px;\n      }\n    }\n  }\n\n  .option {\n    width: 100%;\n    display: flex;\n    margin-top: 18px;\n\n    @media screen and (max-width: 781px) {\n      button {\n        right: 0;\n      }\n    }\n\n    button {\n      margin-left: 11px;\n    }\n    button:first-child {\n      margin-left: 0px !important;\n    }\n  }\n\n  @media (min-width: 781px) {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generate_container": `generate_generate_container__b6Uza`,
	"generate_brand": `generate_generate_brand__FFfDw`,
	"select": `generate_select__DngOU`,
	"subLabel": `generate_subLabel__rzd75`,
	"label": `generate_label__-UD9C`,
	"selectPlan": `generate_selectPlan__Z88EV`,
	"option": `generate_option__y34VO`
};
export default ___CSS_LOADER_EXPORT___;
